var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"columns m-0 p-0"},[_c('div',{staticClass:"column is-6 is-offset-3"},[_c('div',{staticClass:"is-size-1 has-text-centered"},[_vm._v("Valence")]),_c('div',{staticClass:"is-size-6 has-text-centered"},[_vm._v("404 Not Found")])])])
}]

export { render, staticRenderFns }